export default (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="28"
    width="8"
    viewBox="0 0 8 21"
    fill="none"
    {...props}
  >
    <path
      d="M7.47065 10.3207L0.968436 19.9686C0.853663 20.1387 0.553905 20.2146 0.299042 20.1383C0.0438413 20.0618 -0.0699194 19.8619 0.0448533 19.692L6.46369 10.1679L0.0445164 0.643812C-0.0699187 0.473904 0.0438419 0.274063 0.299042 0.197548C0.554243 0.121483 0.854001 0.197098 0.968436 0.367231L7.47065 10.0149C7.5044 10.0646 7.51824 10.1168 7.51487 10.1679C7.51824 10.219 7.5044 10.271 7.47065 10.3207Z"
      fill="#5E6366"
    />
  </svg>
);
